import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { GoogleLogo, CaretLeft } from "@phosphor-icons/react";
import { api } from "../context/AuthContext";
import { GoogleAdsSection } from "../components/GoogleAdsSection";
import { AdsReportCard } from "../components/AdsReportCard";

export default function MarketingGoogleAdsPage() {
  const [params, setParams] = useSearchParams();
  const [adsCfg, setAdsCfg] = useState(null);

  useEffect(() => {
    api.get("/admin/ads/config").then(({ data: c }) => setAdsCfg(c)).catch(() => {});
  }, []);

  useEffect(() => {
    if (params.get("ads_connected")) {
      toast.success("Account Google collegato! Seleziona ora l'account Google Ads da gestire.");
      setParams({}, { replace: true });
    }
    const err = params.get("ads_error");
    if (err) {
      toast.error(`Connessione Google non riuscita: ${err}`);
      setParams({}, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="marketing-googleads-page">
      <div className="mb-10 animate-fade-up">
        <Link to="/marketing" data-testid="back-to-marketing" className="inline-flex items-center gap-1 text-xs font-semibold text-white/50 hover:text-white transition-colors mb-4">
          <CaretLeft size={13} /> Marketing
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2 flex items-center gap-1.5">
          <GoogleLogo size={13} className="text-blue-400" /> Canale Google Ads
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none flex flex-wrap items-center gap-4">
          Google Ads
          {adsCfg && (adsCfg.configured ? (
            <span data-testid="ads-page-status-badge" className="inline-flex items-center h-7 px-3.5 rounded-full bg-emerald-400/10 border border-emerald-400/30 text-[11px] font-semibold uppercase tracking-wider text-emerald-400">Attivo</span>
          ) : (
            <span data-testid="ads-page-status-badge" className="inline-flex items-center h-7 px-3.5 rounded-full bg-amber-400/10 border border-amber-400/30 text-[11px] font-semibold uppercase tracking-wider text-amber-300">Non ancora attivo</span>
          ))}
        </h1>
        <p className="text-sm text-slate-400 mt-3 max-w-2xl">Gestisci le campagne pubblicitarie Google Ads e confronta le performance con il traffico SEO.</p>
      </div>
      <GoogleAdsSection />
      <AdsReportCard />
    </main>
  );
}
